import { createApp } from 'vue'
import App from './App.vue'
import store from './js/store';
import vuetify from "./plugins/vuetify";
import VueRouter from 'vue-router'
import '@mdi/font/css/materialdesignicons.css'

import HelpDialog from '@/components/dialogs/HelpDialog.vue';
import PathHelp from '@/components/dialogs/PathHelp.vue';
import AnyTestHelp from '@/components/dialogs/AnyTestHelp.vue';
import QtHelp from '@/components/dialogs/QtHelp.vue';
import TestEnvHelp from '@/components/dialogs/TestEnvHelp.vue';
import HelpButton from '@/components/buttons/HelpButton.vue';
import CloseButton from '@/components/buttons/CloseButton.vue';

const app = createApp(App)
app.use(store).use(vuetify).use(VueRouter)
app.component("HelpDialog", HelpDialog)
app.component("PathHelp", PathHelp).component("TestEnvHelp", TestEnvHelp).component("AnyTestHelp", AnyTestHelp).component("QtHelp", QtHelp)
app.component("HelpButton", HelpButton).component("CloseButton", CloseButton)
app.mount('#app')
